<template>
    <footer class="footer footer-default">
      <div class="container">
        <nav class="float-left">
          <ul>
            <li>
              <a href="polityka-prywatnosci">Polityka prywatności</a>
            </li>
            <li>|</li>
            <li>
            <a              
              title ="Linked xD - generator wiadomości HR"  
              data-placement="bottom"
              href="http://devpurge.com/linkedxd"
              target="_blank"
            >
              Linked xD - generator wiadomości HR
            </a>
            </li>
          </ul>
        </nav>
        <div class="copyright float-right">
          &copy;
          2019 - 2023 made with
          <i class="material-icons">favorite</i> by
          <a href="http://devpurge.com/" target="_blank">DevPurge</a>
        </div>
      </div>
      <cookie-law  v-bind:buttonText="cookieInfoAcceptBtn">
      <div slot="message" v-html="$t('ui.cookieInfoMessage')">

      </div>

      </cookie-law>
    </footer>
</template>

<script>

import CookieLaw from 'vue-cookie-law'
export default {
    name: "Footer",
    components: { CookieLaw },
    computed: {
    cookieInfoAcceptBtn: function() {
      return  this.$t('ui.cookieInfoAcceptBtn');
      }
    }
}


</script>

<style>
.Cookie__content {
  text-align: justify;
}
</style>
